export type BuildStatus = 'superseded' | 'qa' | 'client' | 'releasing' | 'live';

export function getStatus(
  build: {
    ['@id']: string;
    buildNumber: number;
    platform: string | null;
    qaApprovedAt: string | null;
    buildEvents: Array<{
      type: string;
    }>;
  },
  allBuilds: Array<{
    ['@id']: string;
    buildNumber: number;
    platform: string | null;
  }>
): BuildStatus {
  const isSuperseded = allBuilds.some(
    (b) => b.platform === build.platform && b.buildNumber > build.buildNumber
  );
  if (build.buildEvents.some((be) => be.type === 'live')) {
    return 'live';
  } else if (build.buildEvents.length > 0) {
    return 'releasing';
  } else if (isSuperseded) {
    return 'superseded';
  } else if (build.qaApprovedAt) {
    return 'client';
  } else {
    return 'qa';
  }
}
